import React from 'react';
import PropTypes from 'prop-types';
import mailchimpIcon from '../../../../../../../images/mailchimpIcon.png';
import PendingConnectionModal from '../../../../../common/PendingConnectionModal';

const MailchimpConnectionPage = ({ handleConnect, openedIsOn }) => (
  <div className="mailchimp-connection">
    <img
      alt="mailchimp-logo"
      className="mailchimp-logo"
      src={mailchimpIcon}
      role="presentation"
    />
    <h1>Mailchimp</h1>
    <h2>Connect Mailchimp to Squire to sync your email marketing campaigns</h2>
    <div className="mailchimp-connection__body">
      <p>
        Mailchimp is an email marketing platform that allows you to send emails and automate marketing campaigns to grow your business by keeping clients engaged.
      </p>
      <p>
        Connecting your Squire account will sync your clients and information about them that will enable you to create and send powerful marketing campaigns directly from Mailchimp.
      </p>
    </div>
    <div className="mailchimp-connection__footer">
      <button
        className="c-btn c-btn--primary c-btn--medium"
        data-automation-id="connect-to-mailchimp"
        type="button"
        onClick={handleConnect}
      >
        Connect
      </button>
    </div>
    <PendingConnectionModal
      display-if={openedIsOn}
      text="Please follow the steps in Mailchimp to complete your integration."
    />
  </div>
);

MailchimpConnectionPage.propTypes = {
  handleConnect: PropTypes.func.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
};

export default MailchimpConnectionPage;
